import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import GarageDoorHero from './components/GarageDoorHero';
import GarageDoorServices from './components/GarageDoorServices';
import GarageDoorTypesElPaso from './components/GarageDoorTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import GarageDoorFAQ from './components/GarageDoorFAQ';

export default function GarageDoorPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <GarageDoorHero />
        <GarageDoorServices />
        <GarageDoorTypesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <GarageDoorFAQ />
      </main>
      <Footer />
    </div>
  );
}
